import React, { useCallback, useMemo, useState } from 'react';

function ButtonsList(props) {
    const { fields, showSubtitle, data, multiOptions, currentValue, onChange } = props;
    const [datePickerValue, setDatePickerValue] = useState('');

    const getAllStatuses = useCallback(() => ['new', 'confirmed', 'rejected'], []);

    const handleOnChange = useCallback((value, title) => {
        onChange(value, data.key);
        if (data.name === 'datepicker') {
            setDatePickerValue(title);
        }
    }, [onChange, data]);

    const checkIfAllActive = useCallback((filterValue, key, value) => (
        filterValue === 'all' &&
        key === 'status' &&
        Array.isArray(value) && value.length === 3 &&
        getAllStatuses().every((item) => value.includes(item))
    ), [getAllStatuses]);

    const checkIfNonAllActive = useCallback((filterValue, key, value) => (
        filterValue !== 'all' &&
        key === 'status' &&
        Array.isArray(value) && value.length === 3 &&
        getAllStatuses().every((item) => value.includes(item))
    ), [getAllStatuses]);

    const filters = useMemo(() => fields.find(field => field.key === data.key) || { label: '', list: [], key: '' }, [fields, data.key]);

    return (
        <div className="ButtonsList">
            {showSubtitle && (
                <label className="bold subtitle">{filters.label}</label>
            )}

            {(Array.isArray(filters.list) ? filters.list : []).map((filter, i) => {
                const isAllActive = checkIfAllActive(filter.value, filters.key, currentValue);
                const isNonAllActive = checkIfNonAllActive(filter.value, filters.key, currentValue);

                const className = isAllActive
                    ? 'roundButton--active'
                    : isNonAllActive
                        ? ''
                        : multiOptions
                            ? (Array.isArray(currentValue) && currentValue.includes(filter.value) ? 'roundButton--active' : '')
                            : (filter.value === currentValue || filter.title === datePickerValue ? 'roundButton--active' : '');

                return (
                    <button
                        key={i}
                        className={`roundButton bold ${className}`}
                        onClick={() => handleOnChange(filter.value, filter.title)}
                    >
                        {filter.title}
                    </button>
                );
            })}
        </div>
    );
}

export default ButtonsList;
